import { render, staticRenderFns } from "./rafc-cards.vue?vue&type=template&id=c60a7202&scoped=true"
import script from "./rafc-cards.vue?vue&type=script&lang=js"
export * from "./rafc-cards.vue?vue&type=script&lang=js"
import style0 from "./rafc-cards.vue?vue&type=style&index=0&id=c60a7202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60a7202",
  null
  
)

export default component.exports